import { ServiceInsightDesktopCardProps } from '../../types';
import { ServiceInsightContentDetails } from '../service-insight-details';
import styles from '../service-insight-card.module.scss';

export const ServiceInsightDesktopCard = ({
  serviceInsights
}: ServiceInsightDesktopCardProps) => {
  return (
    <div
      className={`${styles['service-insight-separator']} p-3`}
      data-testid="service-insight"
    >
      <ServiceInsightContentDetails
        serviceInsights={serviceInsights}
        isDesktop
      />
    </div>
  );
};
